import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ResetPasswordRequest } from '../models/account';
import * as sha256 from 'sha256';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  unique_id: string;
  sanitizedUrl;
  id: string;
  email: string;
  new_password: string;
  cnf_password: string;

  passNotMatch = false;
  passNotUppercase = false;
  passNotLowercase = false;
  passNotNumber = false;
  passNotSymbol = false;
  failMessage: string;
  public patternCharacter = '(=!@#$%^&*()~\|<>{}[])';

  upperCase = /[A-Z]/;
  lowerCase = /[a-z]/;
  numbers = /[0-9]/;
  symbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.unique_id = this.route.snapshot.paramMap.get('uniqueId');
    if (this.unique_id != null) {
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
      ) {
        this.sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl('aplcp://forgotpassword?uniqueSourceId=' + this.unique_id);
        $('#openApp').modal('show');
      }

      this.authService.getAccountData(this.unique_id,
        resp => {
          if (resp.alert.code == 200) {
            this.id = resp.data.id;
            this.email = resp.data.email;
          } else
            this.router.navigate(['/']);
        },
        err => { this.router.navigate(['/']); });
    } else
      this.router.navigate(['/']);
  }

  passwordOnChange() {
    if (this.upperCase.test(this.new_password)) {
      this.passNotUppercase = false;
    }
    if (!this.upperCase.test(this.new_password)) {
      this.passNotUppercase = true;
    }
    if (this.lowerCase.test(this.new_password)) {
      this.passNotLowercase = false;
    }
    if (!this.lowerCase.test(this.new_password)) {
      this.passNotLowercase = true;
    }
    if (this.numbers.test(this.new_password)) {
      this.passNotNumber = false;
    }
    if (!this.numbers.test(this.new_password)) {
      this.passNotNumber = true;
    }
    if (this.symbol.test(this.new_password)) {
      this.passNotSymbol = false;
    }
    if (!this.symbol.test(this.new_password)) {
      this.passNotSymbol = true;
    }
  }

  confirmPasswordOnChange() {
    if (this.new_password == this.cnf_password) {
      this.passNotMatch = false;
    }
    if (this.new_password != this.cnf_password) {
      this.passNotMatch = true;
    }
  }

  changePassword(isValid) {
    if (!this.upperCase.test(this.new_password)) {
      this.passNotUppercase = true;
      isValid = false;
    }
    if (!this.lowerCase.test(this.new_password)) {
      this.passNotLowercase = true;
      isValid = false;
    }
    if (!this.numbers.test(this.new_password)) {
      this.passNotNumber = true;
      isValid = false;
    }
    if (!this.symbol.test(this.new_password)) {
      this.passNotSymbol = true;
      isValid = false;
    }
    if (this.new_password != this.cnf_password) {
      this.passNotMatch = true;
      return;
    }
    if (isValid) {
      this.passNotMatch = false;
      const data = new ResetPasswordRequest();
      data.unique_id = this.unique_id;
      data.id = this.id;
      data.email = this.email;
      data.new_password = sha256(this.new_password);
      this.authService.resetPassword(data,
        resp => {
          if (resp.alert.code == 200) {
            $('#success').modal('show');
            setTimeout(() => {
              $('#success').modal('hide');
              this.router.navigate(['/']);
            }, 2000);
          } else {
            this.failMessage = resp.alert.message;
            $('#fail').modal('show');
          }
        },
        err => {
          this.failMessage = err;
          $('#fail').modal('show');
        });
    }
  }
}
